import React from "react";
import { Search, MapPin, Plus } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

const Toolbar = ({ query, onQuery, area, onArea, areas, onSubmitClick }) => {
  return (
    <div className="flex flex-wrap items-center gap-2 px-4 md:px-6 py-2.5 border-b border-neutral-200 bg-[#faf8f4]">
      <div className="relative flex-1 min-w-[180px] max-w-sm">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-neutral-400" />
        <Input
          value={query}
          onChange={(e) => onQuery(e.target.value)}
          placeholder="search karim's, kulfi, hauz khas…"
          className="h-9 rounded-full border-neutral-200 bg-white pl-9 text-sm placeholder:text-neutral-400 focus-visible:ring-neutral-300"
        />
      </div>

      <Select value={area} onValueChange={onArea}>
        <SelectTrigger className="h-9 w-[190px] rounded-full border-neutral-200 bg-white text-sm">
          <MapPin className="mr-1 h-4 w-4 text-neutral-400" />
          <SelectValue placeholder="All neighbourhoods" />
        </SelectTrigger>
        <SelectContent className="max-h-72">
          <SelectItem value="all">All neighbourhoods</SelectItem>
          {areas.map((a) => (
            <SelectItem key={a} value={a}>
              {a}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <div className="ml-auto">
        <Button
          onClick={onSubmitClick}
          className="h-9 rounded-full bg-neutral-900 px-4 text-sm font-medium text-white hover:bg-neutral-800"
        >
          <Plus className="mr-1 h-4 w-4" /> Submit a spot
        </Button>
      </div>
    </div>
  );
};

export default Toolbar;
